import styles from './index.module.scss';
import NotifyIcon from '@/assets/images/bybitsol/notify.svg';
import { useBbSolConfigContext } from '@/hooks/useBboSolInfo';
import { useFm } from '@web3/base-hooks';
import { Tooltip } from '@bfe/moly';
import { PoolInfoProvider, CoinInfoProvider } from '@/components/providers';
import { Operation } from '@/containers/operation';
import { appPath, isMobile } from '@web3/base-utils';
import { formatNumber } from '@web3/base-utils';

export const Header = ({ activity }) => {
  const { solConfig } = useBbSolConfigContext();
  const fm = useFm();
  //
  return (
    <div className={styles.header}>
      <div className={styles.left}>
        <img
          src={
            activity
              ? `/bybit/deadpool/image-0cf948ff59cc4fa496fa9a11217dc4f3.png`
              : solConfig?.airdropConfig?.length > 0
                ? `${appPath}/png/bybitsol/bbsol-gift.png`
                : `${appPath}/png/bybitsol/banner.png`
          }
          alt=""
          className={styles.banner}
        />
        <img
          src={`${appPath}/png/bybitsol/ellipse.png`}
          alt=""
          className={styles.ellipse}
        />
        <h1 className={styles.title}>{fm('bybitStakedSOLBbSOL')}</h1>
        <p className={styles.description}>{fm('getMoreOutOfYourSOL')}</p>
        <div className={styles.rewards}>
          <div className={styles.rewardItem}>
            <div className="flex items-center">
              <div
                className={`${styles.rewardLabel}`}
                style={{ display: 'block' }}
              >
                {fm('totalApyUp')}
              </div>
              <Tooltip title={fm('totalApyWithInc')}>
                <NotifyIcon className={styles.notifyIcon} />
              </Tooltip>
              {/* {solConfig?.airdropConfig?.length > 0 ? (
                <div className={styles.gift}>
                  <img
                    src={`${appPath}/png/bybitsol/gift.png`}
                    alt=""
                    className={styles.giftIcon}
                  />
                  {fm('rewards')}
                </div>
              ) : null} */}
            </div>
            <p className={styles.rewardValue}>{`${formatNumber(solConfig?.apy, {
              kmb: true,
              decimal: 2,
              smallNumberUseValidDigits: false,
              collapseZero: false,
              placeholder: '0.00',
            })}%`}</p>
          </div>
          <div className={styles.divider} />
          <div className={styles.rewardItem}>
            <span className={styles.rewardLabel}>{fm('tvl2')}</span>
            <p className={styles.rewardValue}>{`$${formatNumber(
              solConfig?.tvl,
              {
                kmb: true,
                decimal: 2,
                smallNumberUseValidDigits: false,
                collapseZero: false,
                placeholder: '0.00',
              }
            )}`}</p>
          </div>
          {activity && (
            <>
              <div className={styles.divider} />
              <div className={styles.rewardItem}>
                <span className={styles.rewardLabel}>
                  <img
                    className="w-3 h-3 sm:w-5 sm:h-5"
                    src={`${appPath}/svg/home/fire.svg`}
                    alt="fire"
                  />
                  <span className="ml-1">{fm('superRewards')}</span>
                </span>
                <p className={styles.rewardValue}>
                  {`${formatNumber(activity?.totalRewardAmount, {
                    kmb: true,
                    decimal: 1,
                    smallNumberUseValidDigits: false,
                    collapseZero: false,
                    noTrailZero: true,
                    placeholder: '0.00',
                  })} LAYER`}
                </p>
              </div>
            </>
          )}
        </div>
      </div>
      <div className={styles.right}>
        <PoolInfoProvider id={'77'}>
          <CoinInfoProvider>
            <div className={styles.right}>
              <Operation activity={activity} />
            </div>
          </CoinInfoProvider>
        </PoolInfoProvider>
      </div>
    </div>
  );
};
